import { FormattedMessage } from 'react-intl';

import { Text, TextType } from 'ui-components/components/text';
import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';
import messages from '../messages';

import style from '../style.module.less';

const WarehouseCell = ({ warehouseName }) => (
  <div className={style['warehouse-cell-wrapper']}>
    <Text className={style['warehouse-cell-text']} textType={TextType.Paragraph} value={warehouseName} />
  </div>
);

export const createWarehouseColumnDefinition = (warehouseName) =>
  createColumnDefinitionBuilder({
    accessor: 'warehouseName',
    Header: <FormattedMessage {...messages.warehouseColumnHeader} />,
    Cell: () => <WarehouseCell warehouseName={warehouseName} />,
    width: 150,
  })();
